var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 89,
    viewBox: "0 0 79 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3106 6.04781C37.5719 3.01025 44.2993 4.81287 47.3369 10.0741C50.3745 15.3353 48.5719 22.0628 43.3106 25.1004L20.794 38.1004C15.5328 41.1379 8.80526 39.3353 5.76769 34.0741C2.73013 28.8129 4.53275 22.0854 9.79397 19.0478L32.3106 6.04781ZM43.8728 12.0741C41.9398 8.72604 37.6587 7.57892 34.3106 9.51191L11.794 22.5119C8.44592 24.4449 7.2988 28.726 9.23179 32.0741C11.1648 35.4221 15.4459 36.5693 18.794 34.6363L41.3106 21.6363C44.6587 19.7033 45.8058 15.4221 43.8728 12.0741Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3108 7.77986C37.6154 5.29458 43.1197 6.76946 45.605 11.0741C48.0903 15.3787 46.6154 20.883 42.3108 23.3683L31.0524 29.8683L22.0524 14.2799L33.3108 7.77986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3106 6.04781C37.5719 3.01025 44.2993 4.81287 47.3369 10.0741C50.3745 15.3353 48.5719 22.0628 43.3106 25.1004L30.3203 32.6004L19.3203 13.5478L32.3106 6.04781ZM43.8728 12.0741C41.9398 8.72604 37.6587 7.57892 34.3106 9.51192L24.7844 15.0119L31.7844 27.1363L41.3106 21.6363C44.6587 19.7033 45.8058 15.4221 43.8728 12.0741Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 67.2799C57.0751 67.2799 62 62.355 62 56.2799C62 50.2047 57.0751 45.2799 51 45.2799C44.9249 45.2799 40 50.2047 40 56.2799C40 62.355 44.9249 67.2799 51 67.2799ZM51 71.2799C59.2843 71.2799 66 64.5641 66 56.2799C66 47.9956 59.2843 41.2799 51 41.2799C42.7157 41.2799 36 47.9956 36 56.2799C36 64.5641 42.7157 71.2799 51 71.2799Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7681 68.5382L42.7681 46.0216L46.2322 44.0216L59.2322 66.5382L55.7681 68.5382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.4883fdf08484e9fe4ccf767b386ef87b.svg";
export { ForwardRef as ReactComponent };